import React from 'react';
import { generateCodeExamples } from '../utils/apiDefinitions';
import CodeBlock from './CodeBlock';

const CodeExampleComponent = ({ endpoint, selectedLanguage, setSelectedLanguage }) => {
    // 获取对应语言的代码示例
    const codeExample = generateCodeExamples(endpoint, selectedLanguage);

    // 定义可用的语言选项
    const languages = [
        { value: 'curl', label: 'cURL' },
        { value: 'python', label: 'Python' },
        { value: 'typescript', label: 'TypeScript' },
        { value: 'java', label: 'Java' },
    ];

    return (
        <div>
            <h4 className="font-medium mb-4 text-gray-800">示例代码</h4>
            
            <CodeBlock 
                code={codeExample}
                language={selectedLanguage === 'typescript' ? 'typescript' : 
                          selectedLanguage === 'python' ? 'python' : 
                          selectedLanguage === 'java' ? 'java' : 'bash'}
                languages={languages}
                onLanguageChange={setSelectedLanguage}
            />
        </div>
    );
};

export default CodeExampleComponent; 